<template>
  <div>
    <Header :title="'在线纪念'" />
    <div class="container" :style="bgObj">
      <div class="avator-box">
        <img :src="$resUrl(info.picture)" alt @error="$defImg(require('@/assets/images/avatar-default.png'))">
      </div>
      <div class="name-box">
        <span class="name">{{ info.deadName }}</span>
        <span class="btn" @click="toIntro">简介</span>
      </div>
      <div class="time-box">{{ info.birthDate }} ~ {{ info.deadDate }}</div>
      <div class="info-box">
        <span>到访：{{ info.browseTimes }}</span>
        <span class="mar">墓地祭奠：{{ info.sacrificeCount }}</span>
        <span>留言：{{ info.commentCount }}</span>
      </div>
      <div class="fix-bar flex-row-center-center" @click="toIndex">
        <img src="@/assets/images/hall-home-btnicon.png" alt>
        <span>去祭祀</span>
      </div>
      <div class="out-box flex-row-center-center" @click="out">
        <i class="iconfont">&#xe74b;</i>
        <span>退出</span>
      </div>
    </div>
    <Footer :active="0" />
  </div>
</template>

<script>
import { GetHomeData } from '@/api/Hall/index'
import Header from '@/components/Header/Index'
import Footer from './components/Footer'

export default {
  name: 'HallHome',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      hallId: 0,
      info: {}
    }
  },
  computed: {
    bgObj() {
      const msg = this.info.themeBackgroundUrl
      if (msg) {
        return {
          backgroundImage: `url(${this.$resUrl(msg)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      } else {
        return {
          backgroundImage: 'url(../../assets/images/skin1.jpg)',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat'
        }
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.hallId = this.$route.params.id
      GetHomeData(this.hallId).then(res => {
        res.data.birthDate =
          res.data.birthDate.split('-')[0] +
          '年' +
          res.data.birthDate.split('-')[1] +
          '月' +
          res.data.birthDate.split('-')[2] +
          '日'
        res.data.deadDate =
          res.data.deadDate.split('-')[0] +
          '年' +
          res.data.deadDate.split('-')[1] +
          '月' +
          res.data.deadDate.split('-')[2] +
          '日'
        this.info = res.data
      })
    },
    out() {
      this.$router.push({
        path: '/'
      })
    },
    toIntro() {
      this.$router.push({
        name: 'HallIntroduction',
        params: {
          id: this.$route.params.id
        }
      })
    },
    toIndex() {
      this.$router.push({
        name: 'HallIndex',
        params: {
          id: this.$route.params.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: center;

  .avator-box {
    margin-top: 21vh;
    width: 100px;
    //height: 100px;
    background: #ebe3d6;
    border-radius: 8px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .name-box {
    position: relative;
    max-width: 50%;
    text-align: center;
    margin-top: 28px;
    display: flex;
    align-items: center;

    .name {
      display: block;
      text-align: center;
      width: 100%;
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    .btn {
      position: absolute;
      right: -52px;
      display: inline-block;
      width: 41px;
      height: 21px;
      margin-left: 10px;
      line-height: 21px;
      border: 1px solid #e79822;
      border-radius: 5px;
      text-align: center;
      font-size: 13px;
      color: #e79822;
    }
  }

  .time-box {
    margin-top: 18px;
    margin-bottom: 15px;
    font-size: 12px;
    color: #b6b6b6;
  }

  .info-box {
    font-size: 11px;
    color: #525252;

    .mar {
      margin: 0px 10px;
    }
  }

  .fix-bar {
    position: fixed;
    z-index: 10;
    right: 0px;
    top: 85px;
    width: 93px;
    height: 40px;
    background: url('~@/assets/images/hall-home-button.png');
    background-size: 100% 100%;

    img {
      width: 21px;
      margin-left: 8px;
      margin-right: 6px;
    }

    span {
      font-size: 12px;
      color: #fff;
    }
  }

  .out-box {
    position: fixed;
    z-index: 10;
    left: 0px;
    top: 85px;
    width: 93px;
    height: 40px;
    background: url('~@/assets/images/hall-home-button1.png');
    background-size: 100% 100%;

    i {
      font-size: 21px;
      color: #fff;
      margin-right: 6px;
    }

    span {
      font-size: 12px;
      color: #fff;
    }
  }
}

.skin1 {
  background: url('~@/assets/images/skin1.jpg') no-repeat;
  background-size: 100% 100%;
}
</style>
